export interface GrowlerCustomerAddress {
  cep: string;
  street: string;
  neighborhood: string;
  city: string;
  uf: string;
  number: string;
  complement?: string;
}

export interface GrowlerCustomer {
  id?: string;
  fullName: string;
  whatsapp: string;
  email: string;
  cpf: string;
  birthDate: string;
  condominium: string;
  houseNumber: string;
  address?: GrowlerCustomerAddress;
  uid?: string;
  createdAt?: Date;
}

export const GROWLER_CUSTOMER_STORAGE_KEY = 'growlerCustomer';
export const GROWLER_ORDER_STORAGE_KEY = 'growlerOrderData';
